module.exports = __webpack_public_path__ + "static/media/icon_back_arrow.9f06af2d.svg";